/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { faLongArrowRight } from '@fortawesome/pro-solid-svg-icons'
import Button from '../../components/form/Button'
import Checkbox from '../../components/form/Checkbox'

const QuestionMultiMulti = ({ question, onContinue, buttonStyle }) => {
  const [choiceArray, setChoiceArray] = useState([])
  const [selectedValues, setSelectedValues] = useState([])

  const handleContinue = () => {
    console.log(selectedValues)
    onContinue(selectedValues)
  }

  const handleClick = (e) => {
    const tempArray = choiceArray.map((item) => {
      if (item.label === e.value) {
        /* eslint-disable no-param-reassign */
        item.selected = e.isChecked
      }
      return item
    })

    setChoiceArray(tempArray)

    setSelectedValues(
      tempArray
        .filter((item) => {
          return !!item.selected
        })
        .map((item) => item.label)
    )
  }

  // new question of the same type -> reset
  useEffect(() => {
    const choices = question.options.map((option, i) => {
      return { label: option.value, id: i, selected: false }
    })
    setChoiceArray(choices)
    setSelectedValues([])
  }, [question])

  return (
    <>
      {choiceArray.map((choice) => {
        return (
          <div key={choice.id}>
            <Checkbox
              checked={choice.selected}
              label={choice.label}
              onClick={handleClick}
              id={choice.label}
            />
          </div>
        )
      })}

      <div className="pt-medium">
        <Button
          label=""
          icon={faLongArrowRight}
          customCSS={{ fontSize: '1.5em', margin: 'auto', ...buttonStyle }}
          clickHandler={handleContinue}
          disabled={selectedValues.length === 0}
        />
      </div>
    </>
  )
}

QuestionMultiMulti.defaultProps = {
  buttonStyle: {},
}

QuestionMultiMulti.propTypes = {
  question: PropTypes.shape({
    options: PropTypes.array.isRequired,
    logic: PropTypes.array.isRequired,
  }).isRequired,
  onContinue: PropTypes.func.isRequired,
  buttonStyle: PropTypes.object,
}

export default QuestionMultiMulti
